import {z} from 'zod';

import {optionalNonNegativeIntInput} from './catalogueUi';
import {optionalMoneyInput, priceInput} from './moneyInput';
import {variantTechnicalDataSchema} from './variantTechnicalDataSchema';

export const variantCellSchema = z.object({
  priceNet: priceInput,
  costNet: optionalMoneyInput,
  orderCode: z.string().trim().min(1),
  enabled: z.boolean(),
  gvwKg: optionalNonNegativeIntInput,
  payloadKg: optionalNonNegativeIntInput,
  technicalData: variantTechnicalDataSchema,
});
export type VariantCellValues = z.infer<typeof variantCellSchema>;
